import * as Yup from "yup";
import { toast } from "react-toastify";
import { H2, H3 } from "../Text";
import { Request } from "../../hooks/Request";
import { Circle } from "../Animation";
import { Button } from "../Buttons";
import { requestAuth } from "../services/RequestService";
import { validateArray } from "../../utils/validate";
import { validateType } from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import FormDefault from "../Forms/FormDefault";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import TableComplete from "../Tables/TableComplete";
import { useState } from "react";

const FillDynamicForm = (props) => {
  const navigate = useNavigate();
  const { openDialog, dialogClose } = useDialog();
  const {
    procedure,
    reload,
    onClose,
    rolId,
    step,
    typeId,
    openModal,
    isQuotation = false,
    indexNumber = 'internCode',
    handleSendProcedure = () => { },
  } = props;

  const fieldnames = "facturacion|facturaDeManipuleoDeDocumentos(Pdf)|cm-003-FacturaComercial|f3TotalNúmeroDeBultos|f4TotalPesoBruto|a-TributosYOtrosConceptosAduaneros|b-OtrosGastosDeImportacion/Exportacion|c-GastosDeOperaciones|d-HonorariosProfesionales|e-OtrosGastos|tributosUOtrasGastosPagadosPorElImportador|totalAnticipos";
  const { data, loading, call } = Request({
    // urlApi: `/processstep/${procedure.processStepId}/procedure/${procedure.id}?type=2&isQuotation=${isQuotation}`,
    urlApi: `/processstep/${procedure.processStepId}/procedure/${procedure.id}?type=2&isQuotation=${isQuotation}&isByFields=true&fieldnames=${fieldnames}`,
  });

  const [callSubData, setCallSubData] = useState(true)

  const callForm = () => {
    setCallSubData(x => !x)
  }

  const [searchField, setSearchField] = useState("");

  function handleExcelModal(field) {
    navigate(
      `/rol/${rolId}/procedure-type/${typeId}/step/${step}/procedure/${procedure.id
      }/generate/${field.url}${field.type === "reviewExcel"
        ? "/review"
        : field.type === "correctExcel"
          ? "/answer"
          : ""
      }`
    );
    onClose();
  }

  function dataIntialValues(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]:
          (element.initial === "false" ? false : element.initial) || "",
      };
    });
    return aux;
  }

  function dataFields(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]: element.validate
          ? validateType[element.type] || null
          : null,
      };
    });
    return aux;
  }
  async function onSubmit(values, resetForm, fields) {
    const result = await Promise.all(
      fields.map(async (element) => {
        if (element.type === "file" || element.type === "fileRead") {
          if (
            (values[element.name] === "" || values[element.name] === null) &&
            (element.initial === "" || element.initial === null)
          ) {
            return null;
          } else if (
            (values[element.name] !== "" && !element.initial) ||
            (values[element.name] !== "" &&
              values[element.name] !== element.initial)
          ) {
            let formData = new FormData();
            formData.append("Name", element.name);
            formData.append("File", values[element.name]);
            formData.append("originalName", values[element.name].name);
            formData.append("Status", "verified");
            formData.append("ProcedureId", procedure.id);
            const fileContents = await requestAuth(
              "post",
              "/files",
              formData
            ).then((res) => {
              return {
                Value: res.data.url,
                ProcedureId: procedure.id,
                FieldId: element.id,
                FileId: res.data.id,
              };
            });
            return fileContents;
          } else {
            return {
              Value: element.initial,
              ProcedureId: procedure.id,
              FieldId: element.id,
            };
          }
        } else if (element.type === "selectNewOption") {
          if (values[element.name + "_isNew"]) {
            await handleCreateOption(
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
              element.url
            );
          }
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedure.id,
            FieldId: element.id,
          };
        } else {
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedure.id,
            FieldId: element.id,
          };
        }
      })
    );
    if (procedure.category === "multiple") {
      await submitMultiDataset(
        result.filter((n) => n),
        resetForm,
        values.btnSecondary
      );
    } else {
      await submitDataset(
        result.filter((n) => n),
        resetForm,
        values.btnSecondary
      );
    }
  }

  async function handleCreateOption(value, dropdown) {
    await requestAuth("post", "/dropdown/option", {
      Name: value,
      DropdownListLabel: dropdown,
    });
  }
  async function submitDataset(values, resetForm, btnSecondary) {
    await requestAuth("post", "/dataset" + (props.isGeneral ? "?isGeneral=true" : ""), values)
      .then(() => {
        reload();
        onClose();
        resetForm();
        if (btnSecondary) {
          handleSendProcedure(procedure, reload);
        }
        toast.success("Envio exitoso");
      })
      .catch(() => {
        toast.error("Error en el envio");
      });
  }

  async function submitMultiDataset(values, resetForm, btnSecondary) {
    await requestAuth("get", `/procedure/${procedure.id}/sub-procedures`)
      .then((resp) => {
        submitDataset(
          fillSubProcedures(values, resp.data),
          resetForm,
          btnSecondary
        );
      })
      .catch(() => {
        toast.error("Error en el envio");
      });
  }

  function fillSubProcedures(values, list) {
    let fillProcedure = values;
    list.forEach((element) => {
      const subProcedure = values.map((item) => ({
        ...item,
        ProcedureId: element.id,
      }));
      fillProcedure = [...fillProcedure, ...subProcedure];
    });
    return fillProcedure;
  }

  function handleReaload() {
    call();
    reload();
  }

  function listSubProcedure() {
    openModal(<ListSubProcedure {...props} />);
  }

  function handleRead() {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Estas seguro que quieres extraer los datos del excel?</H3>
        }
        onClose={dialogClose}
        method="post"
        url={`Tradecruz/procedure/${procedure.id}/readerXlsxProforma`}
        texBtn="Extraer"
        handleSuccess={onClose}
      />
    );
  }

  if (!loading) {
    return <Circle />;
  }
  const handleReset = () => {
    setSearchField("");
  };
  return (
    <>
      {validateArray(data.fields) ? (
        <>
          <div className="fixed z-40 top-2 bg-[#e1e7ef] px-1 rounded-md w-[19.5rem] sm:w-auto xl:w-[34rem]">
            <div className="flex flex-col mb-2 items-start">
              <div className="font-semibold">
                {/* {procedure.stepDetail} */}
                Planillaje y Facturación
              </div>
              <div className="font-semibold">
                Llenar formulario de trámite{" "}
                <span className="font-bold text-red-600">
                  {procedure[indexNumber]}
                </span>
              </div>
              {procedure.category === "multiple" && (
                <Button onClick={listSubProcedure} className="py-1 px-3">
                  <i className="fas fa-list-ol"></i>
                </Button>
              )}
            </div>
            <div
              className={`bg-white flex flex-row mb-3 items-center rounded-xl`}
            >
              <label
                htmlFor="searcher"
                className="text-gray-500 font-semibold px-2 py-1"
              >
                <i className="fa fa-search" />{" "}
              </label>
              <input
                id="searcher"
                type="text"
                onChange={(e) => setSearchField(e.target.value.toLowerCase())}
                className="w-full bg-transparent focus:outline-none focus:ring-0 p-1 font-semibold"
                value={searchField}
              />
              <button
                onClick={handleReset}
                className="flex items-center py-1 px-2 bg-gray-200 rounded-full text-gray-500 m-1 hover:bg-gray-300"
              >
                <i className="fa fa-xmark"></i>
              </button>
            </div>
          </div>
          <div className="h-14"></div>
          <FormDefault
            fields={data.fields
              .sort((a, b) => a.order - b.order)
              .map((value, index) => ({
                ...value,
                id: procedure.id,
                code: procedure.internCode,
                fieldId: value.id,
                // labelCustom: (
                //   <>
                //     <span className="font-bold text-green-600">
                //       {index + 1}.
                //     </span>{" "}
                //     {value.label}
                //   </>
                // ),
                label: value.label,
                labelCustom: (
                  <>
                    <span className="text-[#6189ca] font-bold">
                      {index + 1}.
                    </span>{" "}
                    {value.label}
                  </>
                ),
                name: value.name,
                validate: value.validate,
                lockEdition: value.lockEdition,
                placeholder: "Complete el campo",
                type: value.type === "fileRead" ? "file" : value.type,
                typeInput: value.type === "fileRead" ? "file" : value.type,
                initial: value.initial ? value.initial : null,
                urlApi: value.url
                  ? value.url.includes("/")
                    ? value.url
                    : `/Dropdown/${value.url}/options`
                  : "",
                urlApiGroup: value.urlGroup
                  ? value.urlGroup.includes("/")
                    ? value.urlGroup
                    : `/Dropdown/${value.urlGroup}/options`
                  : "",
                urlInitial: value.url,
                value: "name",
                labelOption: "name",
                aditionalClassName: value.label
                  .toLowerCase()
                  .includes(searchField)
                  ? ""
                  : "hidden overflow-hidden",
                action: () => handleExcelModal(value),
                reload: handleReaload,
                step: step,
              }))}
            initialValues={dataIntialValues(data.fields)}
            validationSchema={Yup.object().shape(dataFields(data.fields))}
            onSubmit={async (values, resetForm) =>
              await onSubmit(values, resetForm, data.fields)
            }
            fullData={data}
            buttonFixed={true}
            buttonSecondary={false}
            buttonName="Registrar"
            callForm={callForm}
            callSubData={callSubData}
          />
        </>
      ) : (
        <H3>NO SE TIENE NINGÚN FORMULARIO</H3>
      )}
    </>
  );
};

const ListSubProcedure = (props) => {
  const { procedure, reload, onClose, rolId, step, typeId, openModal } = props;
  const { openDialog, dialogClose } = useDialog();
  const { data, loading, call } = Request({
    urlApi: `/procedure/${procedure.id}/sub-procedures`,
  });

  function createSubProcedure() {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres adicionar un sub tramite?</H3>}
        onClose={dialogClose}
        method="post"
        url={`/Procedure/${procedure.id}/sub-procedures`}
        handleSuccess={call}
        texBtn="Adicionar"
      />
    );
  }
  function formProcedure() {
    openModal(<FillDynamicForm {...props} />);
  }
  function onClick(item) {
    openDialog(
      <FillDynamicForm
        {...props}
        reload={call}
        procedure={item}
        onClose={dialogClose}
      />
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1">
          <Button
            onClick={formProcedure}
            className="py-0.5 px-2 bg-[#FBCE00] text-[#000]"
          >
            <i className="fas fa-chevron-left"></i>
          </Button>
          <H2>Lista de sub procedimientos</H2>
        </div>
        <Button onClick={createSubProcedure} className="py-1 px-3">
          <i className="fas fa-plus"></i>
        </Button>
      </div>
      {!loading ? (
        <Circle />
      ) : data.length > 0 ? (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "id",
                label: "Trámite",
              },
              {
                name: "internCode",
                label: "Nro. interno",
              },
              {
                name: "dimNumber",
                label: "Nro. DIM/DEX",
              },
              // {
              //   name: 'add',
              //   type: 'action',
              //   label: 'Opciones',
              //   sticky: true,
              //   actions: [
              //     {
              //       label: 'Añadir',
              //       icon: 'fas  fa-edit',
              //       action: handleForm,
              //       color: 'text-[#1d4ed8]',
              //     },
              //     {
              //       label: 'Añadir',
              //       icon: 'fas fa-trash',
              //       action: handleDelete,
              //       color: 'text-red-500',
              //     },
              //   ],
              // },
            ]}
            data={data}
            onClick={onClick}
          />
        </div>
      ) : (
        <div className="">No hay tramites</div>
      )}
    </div>
  );
};

export default FillDynamicForm;
